import type { SVGProps } from 'react';

const SvgSettingLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M2 12.8391V11.1609C2 10.1693 2.84958 9.34927 3.89905 9.34927C5.70815 9.34927 6.44778 8.12879 5.53823 6.63179C5.01849 5.77364 5.32834 4.65804 6.23788 4.16222L7.96702 3.21826C8.75662 2.77011 9.77611 3.03709 10.2459 3.79036L10.3558 3.97152C11.2554 5.46852 12.7346 5.46852 13.6442 3.97152L13.7541 3.79036C14.2239 3.03709 15.2434 2.77011 16.033 3.21826L17.7621 4.16222C18.6717 4.65804 18.9815 5.77364 18.4618 6.63179C17.5522 8.12879 18.2919 9.34927 20.1009 9.34927C21.1404 9.34927 22 10.1597 22 11.1609V12.8391C22 13.8307 21.1504 14.6507 20.1009 14.6507C18.2919 14.6507 17.5522 15.8712 18.4618 17.3682C18.9815 18.2359 18.6717 19.342 17.7621 19.8378L16.033 20.7817C15.2434 21.2299 14.2239 20.9629 13.7541 20.2096L13.6442 20.0285C12.7446 18.5315 11.2654 18.5315 10.3558 20.0285L10.2459 20.2096C9.77611 20.9629 8.75662 21.2299 7.96702 20.7817L6.23788 19.8378C5.32834 19.342 5.01849 18.2264 5.53823 17.3682C6.44778 15.8712 5.70815 14.6507 3.89905 14.6507C2.84958 14.6507 2 13.8307 2 12.8391Z'
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z'
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgSettingLt;
